var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button, Dimmer, DropdownDivider, DropdownHeader, Input, Loader, Message, Modal, Select } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import AdminEditKitForm from "../kit/automated-pro/AdminEditKitForm";
import { Accession, BindingSite, ProbeSetFamily, RelevantCatalogType } from "../kit/automated-pro/RnaCatalog";
import { rnaCishKitToAdminFormState } from "../kit/automated-pro/RnaCishKitToAdminFormState";
import { MetaCatalogLoader } from "../kit/Catalog";
import ManualProAdminKitForm from "../kit/manual-pro/ManualProAdminKitForm";
import { manualProKitToAdminFormState } from "../kit/manual-pro/ManualProKitToAdminFormState";
import EditKitForm from "../kit/rna-fish/EditKitForm";
import { isSecondGenVariantName, SimpleCatalogVariantProbeSet, SimpleLibraryOrganismCustomTargetProbeSet, SimpleOtherOrganismCustomTargetProbeSet } from "../kit/rna-fish/KitModel";
import { LoadWrapper } from "../kit/rna-fish/LoadWrapper";
import { ErrorElements } from "../kit/rna-fish/NewRnaFishKitPage";
import { rnaFishKitToFormState } from "../kit/rna-fish/RnaFishKitToFormState";
import { CatalogMode, getWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
import CreateNewColumnPurifiedProbeLotModal from "./CreateNewColumnPurifiedProbeLotModal";
import CreateNewPagePurifiedProbeLotModal from "./CreateNewPagePurifiedProbeLotModal";
import CreateNewUnpurifiedProbeLotModal from "./CreateNewUnpurifiedProbeLotModal";
import { CatalogColumnPurifiedProbeLot, CatalogOrganismCustomTargetColumnPurifiedProbeLot, CatalogOrganismCustomTargetPagePurifiedProbeLot, CatalogOrganismCustomTargetUnpurifiedProbeLot, CatalogPagePurifiedProbeLot, CatalogUnpurifiedProbeLot, CustomColumnPurifiedProbeLot, CustomPagePurifiedProbeLot, CustomUnpurifiedProbeLot, ProbeLotTypeFilter, } from "./ProbeLotTablePage";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
var AssignKitToProbeLotModal = /** @class */ (function (_super) {
    __extends(AssignKitToProbeLotModal, _super);
    function AssignKitToProbeLotModal(props) {
        var _this = _super.call(this, props) || this;
        _this.renderForceAssign = function () {
            var _a;
            var selected = _this.state.forceResults.find(function (pl) { return pl.lotNumber === _this.state.forceSelectedLot; });
            var warnings = selected ? _this.forceAssignWarnings(selected) : [];
            return React.createElement("div", { style: { marginTop: '2rem', borderTop: '1px dashed #bbb', paddingTop: '1rem' } },
                React.createElement("h4", { style: { color: '#a05a00' } }, "Force Assign (admin override)"),
                React.createElement("p", { style: { fontSize: '0.9em', color: '#666' } }, "Search any probe lot by number and assign it to this kit, bypassing compatibility and inventory checks. Use with care \u2014 force-assignments are flagged on the order audit log."),
                React.createElement("div", { style: { display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.5rem' } },
                    React.createElement(Input, { placeholder: 'Lot number (prefix match)', value: _this.state.forceSearchQuery, onChange: _this.onForceSearchChange, style: { flex: 1 } }),
                    React.createElement(Button, { icon: 'search', label: 'Search', labelPosition: 'left', disabled: _this.state.loading || _this.state.forceSearchQuery.trim().length === 0, onClick: _this.runForceSearch })),
                _this.state.forceResults.length > 0 && React.createElement(Select, { placeholder: 'Select a lot to force-assign', value: (_a = _this.state.forceSelectedLot) !== null && _a !== void 0 ? _a : '', onChange: _this.onForceSelectedChange, options: _this.state.forceResults.map(function (pl) { return ({
                        text: pl.lotNumber,
                        value: pl.lotNumber,
                    }); }) }),
                selected && React.createElement("div", { style: { marginTop: '0.75rem' } },
                    React.createElement(Button, { icon: 'warning sign', label: 'Force Assign This Lot', labelPosition: 'left', color: 'orange', disabled: _this.state.loading || _this.state.success, onClick: _this.openForceConfirm })),
                React.createElement(Modal, { size: 'small', open: _this.state.forceConfirmOpen, onClose: _this.cancelForceConfirm },
                    React.createElement(Modal.Header, null, "Confirm Force Assignment"),
                    React.createElement(Modal.Content, null, selected && React.createElement(React.Fragment, null,
                        React.createElement("p", null,
                            "You are about to force-assign lot ",
                            React.createElement("b", null, selected.lotNumber),
                            " to this kit. This bypasses the normal compatibility and inventory checks and will be recorded as a force-assignment on the order audit log."),
                        warnings.length > 0 ? React.createElement(Message, { warning: true },
                            React.createElement(Message.Header, null, "Differences detected"),
                            React.createElement("ul", { style: { marginBottom: 0 } }, warnings.map(function (w, i) { return React.createElement("li", { key: i }, w); }))) : React.createElement(Message, { positive: true }, "No mismatches detected against the kit's expected amplifier / inventory."),
                        React.createElement("div", { style: { marginTop: '1rem' } },
                            React.createElement(Button, { icon: 'cancel', label: 'Cancel', labelPosition: 'left', onClick: _this.cancelForceConfirm }),
                            React.createElement(Button, { icon: 'warning sign', label: 'Yes, force-assign', labelPosition: 'left', color: 'orange', disabled: _this.state.loading || _this.state.success, onClick: _this.confirmForceAssign }))))));
        };
        _this.onModalOpenClick = function () {
            _this.setState({
                confirmModalOpen: true
            });
        };
        _this.cancelConfirmation = function () {
            _this.setState({
                confirmModalOpen: false
            });
        };
        _this.submit = function (forced) {
            if (forced === void 0) { forced = false; }
            return function () {
                _this.setState({
                    loading: true,
                    success: false,
                    confirmModalOpen: false,
                    forceConfirmOpen: false,
                }, function () {
                    var path = "/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/items/id/" + encodeURIComponent(_this.props.item.id) + "/assign-probe-lot";
                    var body;
                    if (_this.props.automatedPro) {
                        body = JSON.stringify(AdminEditKitForm.serializeAutomatedProKit(rnaCishKitToAdminFormState(_this.props.catalog, _this.props.automatedPro, _this.props.automatedProKitPrice)));
                    }
                    else if (_this.props.rnaFishKit) {
                        body = JSON.stringify(EditKitForm.serializeRnaFishKit(rnaFishKitToFormState(_this.props.catalog, _this.props.rnaFishKit, true, _this.props.rnaFishKitPrice)));
                    }
                    else {
                        body = JSON.stringify(ManualProAdminKitForm.serializeManualProAdminKit(manualProKitToAdminFormState(_this.props.catalog, _this.props.manualProKit, _this.props.manualProKitPrice)));
                    }
                    // if we selected a probe lot, send the lot number through a query parameter
                    if (_this.state.assignedProbeLot !== undefined) {
                        path += "?lotNumber=" + encodeURIComponent(_this.state.assignedProbeLot) + "&channel=" + encodeURIComponent(_this.props.channel);
                    }
                    else {
                        path += "?channel=" + encodeURIComponent(_this.props.channel);
                    }
                    if (forced) {
                        path += "&forced=true";
                    }
                    // if this is a probe lot with a different probe set size, send the new probe set size in the path of the request
                    var differentProbeSizeLot = _this.state.differentProbeSetSizeProbeLots
                        .find(function (pl) { return pl.lotNumber === _this.state.assignedProbeLot; });
                    if (differentProbeSizeLot !== undefined) {
                        path = differentProbeSizeLot.customProbeSetSize
                            ? path + "&newProbeSetSize=" + encodeURIComponent(differentProbeSizeLot.customProbeSetSize)
                            : path;
                    }
                    postJsonWithAuthn(path, body)
                        .then(function (resp) {
                        if (resp.status === 400) {
                            return resp.json().then(function (json) {
                                return new ErrorElements(json.errors);
                            });
                        }
                        else if (resp.ok) {
                            return Promise.resolve(undefined);
                        }
                        else {
                            return Promise.resolve(new ErrorElements([{
                                    path: '/',
                                    msg: 'An unexpected error occurred'
                                }]));
                        }
                    })
                        .then(function (json) {
                        if (json !== undefined) {
                            _this.setState({
                                errors: json.errors,
                                loading: false
                            });
                        }
                        else {
                            _this.setState({
                                errors: [],
                                loading: false,
                                success: true
                            });
                        }
                    })
                        .catch(function (rej) {
                        console.error("Couldn't set probe lot: " + rej);
                    });
                });
            };
        };
        _this.createNewProbeLot = function (catalog) {
            var _a, _b;
            var probeLotType;
            var organism;
            var customOrganismName = '';
            var psf;
            var customTargetName = '';
            var variantName;
            var amplifierId;
            var customTargetAccession = '';
            var customTargetMrnaSeq = '';
            var customProbeSetSize = 0;
            var nextProbeLotNumber = '';
            var lotType = '';
            if (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) {
                lotType = ProbeLotTypeFilter.PAGE_PURIFIED;
            }
            else if (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) {
                if ((_a = _this.props.rnaFishKit) === null || _a === void 0 ? void 0 : _a.legacy) {
                    lotType = ProbeLotTypeFilter.UNPURIFIED;
                }
                else if (isSecondGenVariantName(_this.props.probeSet.variant.name)) {
                    lotType = ProbeLotTypeFilter.PAGE_PURIFIED;
                }
                else {
                    lotType = ProbeLotTypeFilter.COLUMN_PURIFIED;
                }
            }
            getWithAuthn("/rna/probe-lot/next-lot-number/type/" + encodeURIComponent(lotType))
                .then(function (resp) {
                if (resp.status === 200) {
                    return resp.json();
                }
                else {
                    return undefined;
                }
            })
                .then(function (resp) {
                nextProbeLotNumber = resp.nextLotNumber;
            });
            if (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) {
                probeLotType = 'Catalog';
                organism = catalog.rnaCatalog.probeSet.catalog.organisms.find(function (o) { return o.id === _this.props.probeSet.organism.id; });
                getWithAuthn("/admin/rna/search/probeSetFamilyId/" + encodeURIComponent(_this.props.probeSet.probeSetFamily.id))
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (jsonFamily) {
                    if (jsonFamily !== undefined && jsonFamily.psf != null) {
                        psf = new ProbeSetFamily(jsonFamily.psf.id, jsonFamily.psf.geneSymbol, jsonFamily.psf.description, jsonFamily.psf.geneType, jsonFamily.psf.accessions, jsonFamily.psf.synonyms, function (psfCreator) {
                            return jsonFamily.psf.variants.map(function (v) {
                                return {
                                    id: v.id,
                                    organism: organism,
                                    probeSetFamily: psfCreator,
                                    name: v.name,
                                    designNumber: v.designNumber,
                                    targetMrnaSeq: v.targetMrnaSeq,
                                    bindingSites: v.bindingSites.map(function (b) { return new BindingSite(b.id, b.rnaVariantId, b.siteNumber, b.startPos, b.endPos, b.onTargetFrac, b.bindingSiteSeq, b.oddSite, b.evenSite, b.probeSeq, b.oddProbe, b.evenProbe, b.createdAt); }),
                                    accession: v.accession ? new Accession(v.accession.id, v.accession.transcriptAccession, v.accession.accessionType, v.accession.transcriptLength, v.accession.transcriptName) : undefined,
                                    probeSetSize: v.probeSetSize,
                                    validated: v.validated,
                                    dcvScore: v.dcvScore,
                                    designType: v.designType
                                };
                            });
                        }, function (psfCreator) {
                            return {
                                id: jsonFamily.psf.defaultVariant.id,
                                organism: organism,
                                probeSetFamily: psfCreator,
                                name: jsonFamily.psf.defaultVariant.name,
                                designNumber: jsonFamily.psf.defaultVariant.designNumber,
                                targetMrnaSeq: jsonFamily.psf.defaultVariant.targetMrnaSeq,
                                bindingSites: jsonFamily.psf.defaultVariant.bindingSites.map(function (b) { return new BindingSite(b.id, b.rnaVariantId, b.siteNumber, b.startPos, b.endPos, b.onTargetFrac, b.bindingSiteSeq, b.oddSite, b.evenSite, b.probeSeq, b.oddProbe, b.evenProbe, b.createdAt); }),
                                accession: jsonFamily.psf.defaultVariant.accession ? new Accession(jsonFamily.psf.defaultVariant.accession.id, jsonFamily.psf.defaultVariant.accession.transcriptAccession, jsonFamily.psf.defaultVariant.accession.accessionType, jsonFamily.psf.defaultVariant.accession.transcriptLength, jsonFamily.psf.defaultVariant.accession.transcriptName) : undefined,
                                probeSetSize: jsonFamily.psf.defaultVariant.probeSetSize,
                                validated: jsonFamily.psf.defaultVariant.validated,
                                dcvScore: jsonFamily.psf.defaultVariant.dcvScore,
                                designType: jsonFamily.psf.defaultVariant.designType
                            };
                        });
                    }
                    else {
                        psf = undefined;
                    }
                });
                variantName = _this.props.probeSet.variant.name;
                amplifierId = _this.props.probeSet.hcrAmplifier.id;
            }
            else if (_this.props.probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet) {
                probeLotType = 'CatalogOrgCustom';
                organism = catalog.rnaCatalog.probeSet.catalog.organisms.find(function (o) { return o.id === _this.props.probeSet.organism.id; });
                customTargetName = _this.props.probeSet.target.name;
                customTargetAccession = _this.props.probeSet.target.accession;
                customTargetMrnaSeq = _this.props.probeSet.target.targetMrnaSeq;
                customProbeSetSize = _this.props.probeSet.probeSetSize;
                amplifierId = _this.props.probeSet.hcrAmplifier.id;
            }
            else {
                probeLotType = 'Custom';
                customOrganismName = _this.props.probeSet.organism.name;
                customTargetName = _this.props.probeSet.target.name;
                customTargetAccession = _this.props.probeSet.target.accession;
                customTargetMrnaSeq = _this.props.probeSet.target.targetMrnaSeq;
                customProbeSetSize = _this.props.probeSet.probeSetSize;
                amplifierId = _this.props.probeSet.hcrAmplifier.id;
            }
            var renderCreateNewPagePurifiedProbeLot = function (props) {
                return React.createElement(CreateNewPagePurifiedProbeLotModal, __assign({ catalog: catalog, probeLotType: probeLotType, organism: organism, customOrganismName: customOrganismName, customTargetName: customTargetName, customTargetAccession: customTargetAccession, customTargetMrnaSeq: customTargetMrnaSeq, customProbeSetSize: customProbeSetSize, probeSetFamily: psf, variantName: variantName, amplifierId: amplifierId, nextProbeLotNumber: nextProbeLotNumber, suppliers: _this.state.suppliers }, props));
            };
            var renderCreateNewColumnPurifiedProbeLot = function (props) {
                return React.createElement(CreateNewColumnPurifiedProbeLotModal, __assign({ catalog: catalog, probeLotType: probeLotType, organism: organism, customOrganismName: customOrganismName, customTargetName: customTargetName, customTargetAccession: customTargetAccession, customTargetMrnaSeq: customTargetMrnaSeq, customProbeSetSize: customProbeSetSize, probeSetFamily: psf, variantName: variantName, amplifierId: amplifierId, nextProbeLotNumber: nextProbeLotNumber, suppliers: _this.state.suppliers }, props));
            };
            var renderCreateNewUnpurifiedProbeLot = function (props) {
                return React.createElement(CreateNewUnpurifiedProbeLotModal, __assign({ catalog: catalog, probeLotType: probeLotType, organism: organism, customOrganismName: customOrganismName, customTargetName: customTargetName, customTargetAccession: customTargetAccession, customTargetMrnaSeq: customTargetMrnaSeq, customProbeSetSize: customProbeSetSize, probeSetFamily: psf, variantName: variantName, amplifierId: amplifierId, nextProbeLotNumber: nextProbeLotNumber, suppliers: _this.state.suppliers }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadAssignableProbeLots, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Create New Probe Lot' }) },
                React.createElement(Modal.Header, null, "Create New Probe Lot"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: _this.props.automatedPro ? renderCreateNewPagePurifiedProbeLot : ((_b = _this.props.rnaFishKit) === null || _b === void 0 ? void 0 : _b.legacy) ? renderCreateNewUnpurifiedProbeLot : renderCreateNewColumnPurifiedProbeLot, successMessage: 'Probe Lot Created' })));
        };
        _this.onAssignedProbeLotChange = function (_, data) {
            var value = data.value;
            if (value === 'NONE') {
                _this.setState({ assignedProbeLot: undefined });
            }
            else {
                _this.setState({ assignedProbeLot: value });
            }
        };
        _this.loadAssignableProbeLots = function () {
            var _a;
            var probeLotType;
            var variantId = '';
            var variantName = '';
            if (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) {
                variantId = _this.props.probeSet.variant.id.toString();
                variantName = _this.props.probeSet.variant.name;
            }
            if (_this.props.automatedPro !== undefined) {
                probeLotType = ProbeLotTypeFilter.PAGE_PURIFIED;
            }
            else if ((_a = _this.props.rnaFishKit) === null || _a === void 0 ? void 0 : _a.legacy) {
                probeLotType = ProbeLotTypeFilter.UNPURIFIED;
            }
            else if (isSecondGenVariantName(variantName)) {
                probeLotType = ProbeLotTypeFilter.PAGE_PURIFIED;
            }
            else {
                probeLotType = ProbeLotTypeFilter.COLUMN_PURIFIED;
            }
            var hcrAmplifierId = _this.props.probeSet.hcrAmplifier.id;
            var perKitScalePmol = _this.props.rnaCishProbeSetComponent ? _this.props.rnaCishProbeSetComponent.scale.pmol : _this.props.rnaFishProbeSetComponent.scale.pmol;
            // the lot must cover every kit in the line, not just one
            var probeSetScalePmol = perKitScalePmol * _this.props.item.quantity;
            _this.setState({ requiredScalePmol: probeSetScalePmol });
            var queryParams = "?probeLotType=" + probeLotType + "&hcrAmplifierId=" + hcrAmplifierId + "&variantId=" + variantId + "&probeSetScalePmol=" + probeSetScalePmol;
            getWithAuthn("/rna/probe-lots" + queryParams)
                .then(function (resp) {
                if (resp.status === 200) {
                    return resp.json();
                }
                else {
                    return undefined;
                }
            })
                .then(function (resp) {
                if (resp === undefined) {
                    _this.setState({});
                }
                else {
                    var responseProbeLots = resp.probeLots.probeLots.map(_this.deserializeProbeLot);
                    _this.setState({
                        probeLots: responseProbeLots.filter(function (pl) {
                            return (_this.props.probeSet instanceof SimpleCatalogVariantProbeSet) ||
                                (_this.props.probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet && pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot &&
                                    pl.customProbeSetSize === _this.props.probeSet.probeSetSize) ||
                                (_this.props.probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet && (pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot) &&
                                    pl.customProbeSetSize === _this.props.probeSet.probeSetSize) ||
                                (_this.props.probeSet instanceof SimpleOtherOrganismCustomTargetProbeSet && pl instanceof CustomPagePurifiedProbeLot &&
                                    pl.customProbeSetSize === _this.props.probeSet.probeSetSize) ||
                                (_this.props.probeSet instanceof SimpleOtherOrganismCustomTargetProbeSet && (pl instanceof CustomUnpurifiedProbeLot || pl instanceof CustomColumnPurifiedProbeLot) &&
                                    pl.customProbeSetSize === _this.props.probeSet.probeSetSize);
                        }),
                        differentProbeSetSizeProbeLots: responseProbeLots.filter(function (pl) {
                            return (_this.props.probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet && pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot &&
                                pl.customProbeSetSize !== _this.props.probeSet.probeSetSize) ||
                                (_this.props.probeSet instanceof SimpleLibraryOrganismCustomTargetProbeSet && (pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot) &&
                                    pl.customProbeSetSize !== _this.props.probeSet.probeSetSize) ||
                                (_this.props.probeSet instanceof SimpleOtherOrganismCustomTargetProbeSet && pl instanceof CustomPagePurifiedProbeLot &&
                                    pl.customProbeSetSize !== _this.props.probeSet.probeSetSize) ||
                                (_this.props.probeSet instanceof SimpleOtherOrganismCustomTargetProbeSet && (pl instanceof CustomUnpurifiedProbeLot || pl instanceof CustomColumnPurifiedProbeLot) &&
                                    pl.customProbeSetSize !== _this.props.probeSet.probeSetSize);
                        }),
                        suppliers: resp.suppliers
                    });
                }
            })
                .catch(function (rej) {
                console.error("Couldn't load probe lots: " + rej);
            });
        };
        _this.deserializeProbeLot = function (pl) {
            switch (pl._type) {
                case 'CatalogPagePurifiedProbeLot':
                    var catalogPurifiedSplitPl = pl;
                    return new CatalogPagePurifiedProbeLot(catalogPurifiedSplitPl._type, catalogPurifiedSplitPl.id, catalogPurifiedSplitPl.lotNumber, catalogPurifiedSplitPl.deactivated, catalogPurifiedSplitPl.reasonForDeactivation, catalogPurifiedSplitPl.hcrAmplifier, catalogPurifiedSplitPl.validation, catalogPurifiedSplitPl.organism, catalogPurifiedSplitPl.geneSymbol, catalogPurifiedSplitPl.variant, catalogPurifiedSplitPl.designNumber, catalogPurifiedSplitPl.accession, catalogPurifiedSplitPl.sequence, catalogPurifiedSplitPl.probeSetSize, catalogPurifiedSplitPl.params);
                case 'CatalogOrganismCustomTargetPagePurifiedProbeLot':
                    var catalogOrgCustomTargetPurifiedSplitPl = pl;
                    return new CatalogOrganismCustomTargetPagePurifiedProbeLot(catalogOrgCustomTargetPurifiedSplitPl._type, catalogOrgCustomTargetPurifiedSplitPl.id, catalogOrgCustomTargetPurifiedSplitPl.lotNumber, catalogOrgCustomTargetPurifiedSplitPl.deactivated, catalogOrgCustomTargetPurifiedSplitPl.reasonForDeactivation, catalogOrgCustomTargetPurifiedSplitPl.hcrAmplifier, catalogOrgCustomTargetPurifiedSplitPl.validation, catalogOrgCustomTargetPurifiedSplitPl.organism, catalogOrgCustomTargetPurifiedSplitPl.customGeneSymbolName, catalogOrgCustomTargetPurifiedSplitPl.customVariantName, catalogOrgCustomTargetPurifiedSplitPl.customAccession, catalogOrgCustomTargetPurifiedSplitPl.customSequence, catalogOrgCustomTargetPurifiedSplitPl.customProbeSetSize, catalogOrgCustomTargetPurifiedSplitPl.params);
                case 'CustomPagePurifiedProbeLot':
                    var customPurifiedSplitPl = pl;
                    return new CustomPagePurifiedProbeLot(customPurifiedSplitPl._type, customPurifiedSplitPl.id, customPurifiedSplitPl.lotNumber, customPurifiedSplitPl.deactivated, customPurifiedSplitPl.reasonForDeactivation, customPurifiedSplitPl.hcrAmplifier, customPurifiedSplitPl.validation, customPurifiedSplitPl.customOrganismName, customPurifiedSplitPl.customGeneSymbolName, customPurifiedSplitPl.customVariantName, customPurifiedSplitPl.customAccession, customPurifiedSplitPl.customSequence, customPurifiedSplitPl.customProbeSetSize, customPurifiedSplitPl.params);
                case 'CatalogColumnPurifiedProbeLot':
                    var catalogPurifiedMergedPl = pl;
                    return new CatalogColumnPurifiedProbeLot(catalogPurifiedMergedPl._type, catalogPurifiedMergedPl.id, catalogPurifiedMergedPl.lotNumber, catalogPurifiedMergedPl.deactivated, catalogPurifiedMergedPl.reasonForDeactivation, catalogPurifiedMergedPl.hcrAmplifier, catalogPurifiedMergedPl.validation, catalogPurifiedMergedPl.organism, catalogPurifiedMergedPl.geneSymbol, catalogPurifiedMergedPl.variant, catalogPurifiedMergedPl.designNumber, catalogPurifiedMergedPl.accession, catalogPurifiedMergedPl.sequence, catalogPurifiedMergedPl.probeSetSize, catalogPurifiedMergedPl.params);
                case 'CatalogOrganismCustomTargetColumnPurifiedProbeLot':
                    var catalogOrgCustomTargetPurifiedMergedPl = pl;
                    return new CatalogOrganismCustomTargetColumnPurifiedProbeLot(catalogOrgCustomTargetPurifiedMergedPl._type, catalogOrgCustomTargetPurifiedMergedPl.id, catalogOrgCustomTargetPurifiedMergedPl.lotNumber, catalogOrgCustomTargetPurifiedMergedPl.deactivated, catalogOrgCustomTargetPurifiedMergedPl.reasonForDeactivation, catalogOrgCustomTargetPurifiedMergedPl.hcrAmplifier, catalogOrgCustomTargetPurifiedMergedPl.validation, catalogOrgCustomTargetPurifiedMergedPl.organism, catalogOrgCustomTargetPurifiedMergedPl.customGeneSymbolName, catalogOrgCustomTargetPurifiedMergedPl.customVariantName, catalogOrgCustomTargetPurifiedMergedPl.customAccession, catalogOrgCustomTargetPurifiedMergedPl.customSequence, catalogOrgCustomTargetPurifiedMergedPl.customProbeSetSize, catalogOrgCustomTargetPurifiedMergedPl.params);
                case 'CustomColumnPurifiedProbeLot':
                    var customPurifiedMergedPl = pl;
                    return new CustomColumnPurifiedProbeLot(customPurifiedMergedPl._type, customPurifiedMergedPl.id, customPurifiedMergedPl.lotNumber, customPurifiedMergedPl.deactivated, customPurifiedMergedPl.reasonForDeactivation, customPurifiedMergedPl.hcrAmplifier, customPurifiedMergedPl.validation, customPurifiedMergedPl.customOrganismName, customPurifiedMergedPl.customGeneSymbolName, customPurifiedMergedPl.customVariantName, customPurifiedMergedPl.customAccession, customPurifiedMergedPl.customSequence, customPurifiedMergedPl.customProbeSetSize, customPurifiedMergedPl.params);
                case 'CatalogUnpurifiedProbeLot':
                    var catalogUnpurifiedPl = pl;
                    return new CatalogUnpurifiedProbeLot(catalogUnpurifiedPl._type, catalogUnpurifiedPl.id, catalogUnpurifiedPl.lotNumber, catalogUnpurifiedPl.deactivated, catalogUnpurifiedPl.reasonForDeactivation, catalogUnpurifiedPl.hcrAmplifier, catalogUnpurifiedPl.validation, catalogUnpurifiedPl.organism, catalogUnpurifiedPl.geneSymbol, catalogUnpurifiedPl.variant, catalogUnpurifiedPl.designNumber, catalogUnpurifiedPl.accession, catalogUnpurifiedPl.sequence, catalogUnpurifiedPl.probeSetSize, catalogUnpurifiedPl.params);
                case 'CatalogOrganismCustomTargetUnpurifiedProbeLot':
                    var catalogOrgCustomTargetUnpurifiedPl = pl;
                    return new CatalogOrganismCustomTargetUnpurifiedProbeLot(catalogOrgCustomTargetUnpurifiedPl._type, catalogOrgCustomTargetUnpurifiedPl.id, catalogOrgCustomTargetUnpurifiedPl.lotNumber, catalogOrgCustomTargetUnpurifiedPl.deactivated, catalogOrgCustomTargetUnpurifiedPl.reasonForDeactivation, catalogOrgCustomTargetUnpurifiedPl.hcrAmplifier, catalogOrgCustomTargetUnpurifiedPl.validation, catalogOrgCustomTargetUnpurifiedPl.organism, catalogOrgCustomTargetUnpurifiedPl.customGeneSymbolName, catalogOrgCustomTargetUnpurifiedPl.customVariantName, catalogOrgCustomTargetUnpurifiedPl.customAccession, catalogOrgCustomTargetUnpurifiedPl.customSequence, catalogOrgCustomTargetUnpurifiedPl.customProbeSetSize, catalogOrgCustomTargetUnpurifiedPl.params);
                case 'CustomUnpurifiedProbeLot':
                    var customUnpurifiedPl = pl;
                    return new CustomUnpurifiedProbeLot(customUnpurifiedPl._type, customUnpurifiedPl.id, customUnpurifiedPl.lotNumber, customUnpurifiedPl.deactivated, customUnpurifiedPl.reasonForDeactivation, customUnpurifiedPl.hcrAmplifier, customUnpurifiedPl.validation, customUnpurifiedPl.customOrganismName, customUnpurifiedPl.customGeneSymbolName, customUnpurifiedPl.customVariantName, customUnpurifiedPl.customAccession, customUnpurifiedPl.customSequence, customUnpurifiedPl.customProbeSetSize, customUnpurifiedPl.params);
                default:
                    throw new Error("Unknown type: " + pl._type);
            }
        };
        _this.onForceSearchChange = function (_, data) {
            _this.setState({ forceSearchQuery: data.value });
        };
        _this.runForceSearch = function () {
            var query = _this.state.forceSearchQuery.trim();
            if (query.length === 0) {
                _this.setState({ forceResults: [], forceSelectedLot: undefined });
                return;
            }
            _this.setState({ loading: true });
            getWithAuthn("/rna/probe-lots?probeLotFilter=" + encodeURIComponent(query))
                .then(function (resp) { return resp.status === 200 ? resp.json() : undefined; })
                .then(function (resp) {
                if (resp === undefined) {
                    _this.setState({ loading: false, forceResults: [] });
                }
                else {
                    _this.setState({
                        loading: false,
                        forceResults: resp.probeLots.probeLots.map(_this.deserializeProbeLot),
                        forceSelectedLot: undefined,
                    });
                }
            })
                .catch(function (rej) {
                console.error("Couldn't search probe lots: " + rej);
                _this.setState({ loading: false });
            });
        };
        _this.onForceSelectedChange = function (_, data) {
            _this.setState({ forceSelectedLot: data.value });
        };
        _this.openForceConfirm = function () {
            if (_this.state.forceSelectedLot === undefined) {
                return;
            }
            _this.setState({ forceConfirmOpen: true });
        };
        _this.cancelForceConfirm = function () {
            _this.setState({ forceConfirmOpen: false });
        };
        _this.confirmForceAssign = function () {
            _this.setState({ assignedProbeLot: _this.state.forceSelectedLot }, _this.submit(true));
        };
        _this.lotInventoryAvailable = function (pl) {
            var _a;
            if (pl instanceof CatalogPagePurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot || pl instanceof CustomPagePurifiedProbeLot) {
                var odd = pl.params.currentOddInventory;
                var even = pl.params.currentEvenInventory;
                if (odd == null || even == null) {
                    return undefined;
                }
                return Math.min(odd, even);
            }
            return (_a = pl.params.currentInventory) !== null && _a !== void 0 ? _a : undefined;
        };
        _this.forceAssignWarnings = function (lot) {
            var warnings = [];
            if (lot.hcrAmplifier.id !== _this.props.probeSet.hcrAmplifier.id) {
                warnings.push("Amplifier mismatch \u2014 lot uses " + lot.hcrAmplifier.id + ", kit expects " + _this.props.probeSet.hcrAmplifier.id + ".");
            }
            if (lot.deactivated) {
                warnings.push("Lot is deactivated" + (lot.reasonForDeactivation ? " (" + lot.reasonForDeactivation + ")" : '') + ".");
            }
            var inv = _this.lotInventoryAvailable(lot);
            if (inv === undefined) {
                warnings.push("Lot has no recorded inventory yield \u2014 inventory impact cannot be verified.");
            }
            else if (inv - _this.state.requiredScalePmol < 0) {
                warnings.push("Assigning will put inventory negative (" + (inv - _this.state.requiredScalePmol).toFixed(1) + " pmol after assignment).");
            }
            return warnings;
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            probeLots: [],
            differentProbeSetSizeProbeLots: [],
            assignedProbeLot: _this.props.probeSet.probeLotNumber ? _this.props.probeSet.probeLotNumber : undefined,
            confirmModalOpen: false,
            suppliers: [],
            requiredScalePmol: 0,
            forceSearchQuery: '',
            forceResults: [],
            forceSelectedLot: undefined,
            forceConfirmOpen: false,
        };
        return _this;
    }
    AssignKitToProbeLotModal.prototype.componentDidMount = function () {
        this.loadAssignableProbeLots();
    };
    AssignKitToProbeLotModal.prototype.render = function () {
        var _this = this;
        var differentProbeSetSizeProbeLot = this.state.differentProbeSetSizeProbeLots.find(function (pl) { return pl.lotNumber === _this.state.assignedProbeLot; });
        return React.createElement(Dimmer.Dimmable, null,
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/kitProbeLot', labelContent: 'Assign Kit Probe Lot' },
                React.createElement(Select, { options: [{
                            text: 'None',
                            description: '',
                            value: 'NONE'
                        }].concat([
                        React.createElement(DropdownHeader, { key: 'compatible-header', content: 'Compatible Lots' }),
                        React.createElement(DropdownDivider, { key: 'compatible-divider' })
                    ]).concat(this.state.probeLots.map(function (pl) {
                        if (pl instanceof CatalogPagePurifiedProbeLot || pl instanceof CatalogColumnPurifiedProbeLot || pl instanceof CatalogUnpurifiedProbeLot) {
                            return {
                                text: pl.lotNumber,
                                description: "Catalog: " + pl.organism + " " + pl.geneSymbol + " " + pl.variant + " " + pl.hcrAmplifier.id,
                                value: pl.lotNumber
                            };
                        }
                        else if (pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot) {
                            return {
                                text: pl.lotNumber,
                                description: "Custom: " + pl.organism + " " + pl.customGeneSymbolName + " " + pl.hcrAmplifier.id,
                                value: pl.lotNumber
                            };
                        }
                        else {
                            return {
                                text: pl.lotNumber,
                                description: "Custom: " + pl.customOrganismName + " " + pl.customGeneSymbolName + " " + pl.hcrAmplifier.id,
                                value: pl.lotNumber
                            };
                        }
                    }))
                        .concat([
                        React.createElement(DropdownHeader, { key: 'incompatible-header', content: 'Different Probe Size Lots' }),
                        React.createElement(DropdownDivider, { key: 'incompatible-divider' })
                    ])
                        .concat(this.state.differentProbeSetSizeProbeLots.map(function (pl) {
                        if (pl instanceof CatalogOrganismCustomTargetPagePurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetColumnPurifiedProbeLot || pl instanceof CatalogOrganismCustomTargetUnpurifiedProbeLot) {
                            return {
                                text: pl.lotNumber,
                                description: "Custom: " + pl.organism + " " + pl.customGeneSymbolName + " " + pl.hcrAmplifier.id + " " + pl.customProbeSetSize,
                                value: pl.lotNumber
                            };
                        }
                        else {
                            return {
                                text: pl.lotNumber,
                                description: "Custom: " + pl.customOrganismName + " " + pl.customGeneSymbolName + " " + pl.hcrAmplifier.id + " " + pl.customProbeSetSize,
                                value: pl.lotNumber
                            };
                        }
                    })), search: true, placeholder: 'Please enter a probe lot number', onChange: this.onAssignedProbeLotChange, value: this.state.assignedProbeLot ? this.state.assignedProbeLot : 'NONE' })),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Probe lot assigned."),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            differentProbeSetSizeProbeLot !== undefined ?
                React.createElement(Modal, { closeIcon: true, size: 'small', trigger: React.createElement(Button, { disabled: this.state.loading || this.state.success, onClick: this.onModalOpenClick, icon: 'save', label: 'Assign Probe Lot', labelPosition: 'left', positive: true }), open: this.state.confirmModalOpen, onClose: this.cancelConfirmation },
                    React.createElement(Modal.Header, null, "Confirm Assignment"),
                    React.createElement(Modal.Content, null,
                        React.createElement("p", { style: { fontWeight: 'bold', whiteSpace: "pre-line" } }, "Are you sure you want to change the kits's probe size to " + differentProbeSetSizeProbeLot.customProbeSetSize + " and assign it to " + this.state.assignedProbeLot + "?"),
                        React.createElement(Button, { className: 'fish-button', disabled: this.props.state.loading || this.props.state.success, icon: 'cancel', label: 'Cancel', labelPosition: 'left', onClick: this.cancelConfirmation, negative: true }),
                        React.createElement(Button, { className: 'fish-button', disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Confirm', labelPosition: 'left', onClick: this.submit(), positive: true }))) : React.createElement(Button, { disabled: this.state.loading || this.state.success, icon: 'save', label: 'Assign Probe Lot', labelPosition: 'left', onClick: this.submit(), positive: true }),
            React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Cart), render: this.createNewProbeLot }),
            this.renderForceAssign());
    };
    return AssignKitToProbeLotModal;
}(React.PureComponent));
export default AssignKitToProbeLotModal;
//# sourceMappingURL=AssignKitToProbeLotModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AssignKitToProbeLotModal.js
// module id = 1245
// module chunks = 0